import { Badge } from '../components/ui/Button.tsx';

/** 전체공지 공개 조회 (CR-030): GET /public/notices/grid · /public/notices/:id 응답. 운영 정보(대상·메일·등록자)는 없다 */
export interface PublicNotice { id: string; title: string; body: string; level: string; startsAt: string; endsAt: string; createdAt: string }

export const NOTICE_LEVEL: Record<string, { label: string; tone: 'info' | 'warning' }> = { info: { label: '안내', tone: 'info' }, warning: { label: '중요', tone: 'warning' } };
export function LevelBadge({ level }: { level: string }) {
  const l = NOTICE_LEVEL[level] ?? { label: level, tone: 'info' as const };
  return <Badge tone={l.tone}>{l.label}</Badge>;
}
/** 등록일 표기: 브라우저 시간대 기준 YYYY-MM-DD */
export { fmtDate as ymd } from './date.ts';
